import { useDisclosure } from "@heroui/react";
import { InputField, ModalBuilder, ModalError } from "../modalBuilder";
import { api } from "@/api";
import { toast } from "react-toastify";
import useErrorHandling from "@/hooks/useErrorHandling";
import { useState } from "react";
import { Workplace, WorkplaceUpdate } from "@/api/offices";
import { loadHandbooks } from "@/utils/loadHandbooks";

export const editWorkplaceFields: InputField[] = [
  {
    label: "Название",
    name: "display_name",
    placeholder: "Рабочее место 1",
    type: "text",
    isRequired: true,
  },
];

export function EditWorkplaceModal({
  disclosure,
  workplace,
  officeId,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
  workplace: Workplace | null;
  officeId: number;
}) {
  const { isOpen, onOpenChange } = disclosure;
  const [modalErrors, setModalErrors] = useState<ModalError[]>([]);
  const handleError = useErrorHandling();

  const onSubmit = (data: WorkplaceUpdate) => {
    if (!workplace) return Promise.resolve(false);

    return new Promise<boolean>((resolve) => {
      setModalErrors([]);
      api.offices.workplaces
        .update(officeId, workplace.id, data)
        .then(() => {
          toast.success("Рабочее место успешно обновлено!");
          loadHandbooks({ handbooks: ["workplaces"] });
          onOpenChange();
          resolve(true);
        })
        .catch((err) => {
          const { errorMessage, parsedErrors } = handleError(err);
          toast.error(errorMessage);
          setModalErrors(parsedErrors || []);
          resolve(false);
        });
    });
  };

  const onDelete = () => {
    if (!workplace) return Promise.resolve(false);

    return new Promise<boolean>((resolve) => {
      api.offices.workplaces
        .delete(officeId, workplace.id)
        .then(() => {
          toast.success("Рабочее место успешно удалено!");
          loadHandbooks({ handbooks: ["workplaces"] });
          onOpenChange();
          resolve(true);
        })
        .catch((err) => {
          const { errorMessage } = handleError(err);
          toast.error(errorMessage);
          resolve(false);
        });
    });
  };

  return (
    <ModalBuilder
      title="Редактирование рабочего места"
      fields={editWorkplaceFields}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      modalErrors={modalErrors}
      onSubmit={onSubmit}
      onDelete={onDelete}
      isSensitiveData={true}
      submitButtonText="Сохранить"
      deleteButtonText="Удалить"
      defaultValues={{
        display_name: workplace?.display_name || "",
        office_id: officeId,
      }}
    />
  );
}
